import { handleChange } from '@helpers/handleChange';
import { StoreState } from '@interfaces/stores';
import { userGroupsService } from '@services/domain-factories/userGroups';
import { createStoreWithSelector } from '@utils/zustand/createStoreWithSelector';
import { createUseStore } from '@utils/zustand/createUseStore';
import { initOnce } from '@utils/zustand/initOnce';
import { WithReset } from '@utils/zustand/zustandTypes';
import { UserGroup } from '@vincerosoft/assessfluence-types';

type Actions = {
  initUserGroups: () => Promise<void>;
  handleChange: (...args: [userGroup: UserGroup] | [userGroupId: string, isDelete: true]) => void;
};

const initialValue: StoreState['userGroups'] = {
  userGroups: null,
  loading: false,
  inFlightInit: null,
  isInitialized: false
};

export const globalUserGroupsStore = createStoreWithSelector<
  WithReset<StoreState['userGroups'] & Actions>
>()((set, get) => ({
  ...initialValue,

  initUserGroups: () =>
    initOnce(
      'isInitialized',
      set,
      get,
      () => userGroupsService.loadUserGroupsStore((userGroups) => set({ userGroups })),
      (userGroups) => set({ userGroups })
    ),

  handleChange: (...args) => {
    const [change, isDelete = false] = args;
    set((state) => ({
      userGroups: handleChange(state.userGroups, change, isDelete)
    }));
  },

  reset: () => set(initialValue)
}));

export const useGlobalUserGroupsStore = createUseStore(globalUserGroupsStore);
